import { render } from "./ListOfAnnouncements.vue?vue&type=template&id=ad759582"
import script from "./ListOfAnnouncements.vue?vue&type=script&lang=js"
export * from "./ListOfAnnouncements.vue?vue&type=script&lang=js"

import "./ListOfAnnouncements.vue?vue&type=style&index=0&id=ad759582&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__